export interface ExperienceMode {
  id: 'family' | 'vip' | 'all'
  group: string
  behaviour: string
}

/** The same number, handled differently depending on who is calling. */
export const experienceModes: ExperienceMode[] = [
  { id: 'family', group: 'Family', behaviour: 'Personal · Emergency detection ON' },
  {
    id: 'vip',
    group: 'VIP Clients',
    behaviour: 'Professional · Calendar booking allowed',
  },
  { id: 'all', group: 'Everyone else', behaviour: 'Default experience' },
]
